import React, { useEffect, useState, useRef, Fragment } from "react";
import { BrowserRouter, Routes, Route, useParams, useSearchParams } from "react-router-dom";
import Papa from "papaparse";

function NotesSchedule() {
  const [data, setData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [forWeekOfDay, setForWeekOfDay] = useState(useParams().dayString);
  const [endOfPeriod, setEndOfPeriod] = useState(useParams().endOfPeriod);
  let showAddress = searchParams.get("show_address") === "true";
  let showTransportation = searchParams.get("show_transportation");
  let startOfWeek, endOfWeek;
  if (forWeekOfDay) {
    const [month, day, year] = forWeekOfDay.split("-").map(Number);
    const inputDate = new Date(year, month - 1, day);

    const [monthEnd, dayEnd, yearEnd] = endOfPeriod.split("-").map(Number);
    const endDate = new Date(yearEnd, monthEnd - 1, dayEnd);

    // Get day of week (0 = Sunday, 6 = Saturday)
    const dayOfWeek = inputDate.getDay();

    // Calculate start and end of week
    startOfWeek = new Date(inputDate);
    startOfWeek.setHours(0, 0, 0, 0);
    // startOfWeek.setDate(inputDate.getDate() - dayOfWeek);

    endOfWeek = new Date(endDate);
    endOfWeek.setHours(23, 59, 59, 999);
    // endOfWeek.setDate(inputDate.getDate() + (6 - dayOfWeek));
  }

  useEffect(() => {
    // const link = document.createElement("link");
    // link.rel = "stylesheet";
    // link.href = "/print.css";
    // link.media = "print";
    // document.head.appendChild(link);

    Papa.parse(`https://docs.google.com/spreadsheets/d/1agD_PdBRs4L7EGjUXJkwx6baHmZIuedcl7cXeklxBwU/export?format=csv&v=${Date.now()}`, {
      download: true,
      header: true,

      complete: (results) => {
        let processed = [];
        results.data.map((event) => {
          // Split the date
          let allDay = false;
          let shouldProcess = true;
          const [month, day, year] = event["Game Date"].substring(0, 10).split("/");

          // Parse time and convert to 24-hour format
          const [time, meridiem] = event["Game Time"].split(" ");
          let [hour, minute] = time.split(":").map(Number);
          try {
            if (meridiem.toUpperCase() === "PM" && hour !== 12) {
              hour += 12;
            } else if (meridiem.toUpperCase() === "AM" && hour === 12) {
              hour = 0;
            }
          } catch (error) {
            console.log(error);
            hour = "";
            minute = "";
            allDay = true;
          }

          // Create the date object in local time
          const date = new Date(year, month - 1, day, hour, minute);

          // Convert to ISO 8601 format (UTC)
          const startISOString = date.toISOString();
          if (forWeekOfDay) {
            console.log(startISOString);
            console.log(startOfWeek.toISOString());
            shouldProcess = startISOString >= startOfWeek.toISOString() && startISOString <= endOfWeek.toISOString();
            console.log(shouldProcess);
          }
          switch (showTransportation) {
            case "Bus":
              shouldProcess = shouldProcess && event["Transportation"] === "Bus";
              break;
            case "Walk":
              shouldProcess = shouldProcess && event["Transportation"] === "Walk";
              break;
            default:
            // code block
          }
          // shouldProcess = shouldProcess && event["Cancelled Ind"] !== "1"; // Exclude cancelled events
          // shouldProcess = shouldProcess && event["Rescheduled Ind"] !== "1"; // Exclude cancelled events

          shouldProcess &&
            processed.push({
              teamID: event["Group ID"],
              date: event["Game Date"].substring(0, 10),
              actualTitle: event["Title"],
              title: event["Sport Level Title"] + " - " + event["Name"],
              isCancelled: event["Cancelled Ind"] == "1",
              isRescheduled: event["Rescheduled Ind"] == "1",
              team: event["Sport Level Title"],
              scrimmage: event["Scrimmage Ind"] === "Yes",
              away: event["Home/Away"].indexOf("Away") > -1,
              dismissal: event["Student Dismissal Time"],
              address: event["Room Name"]
                ? "3901 Fieldston Road, Bronx, NY, 10417"
                : event["Line One"].length > 0
                ? event["Line One"] + ", " + event["City"] + ", " + event["State"] + " " + event["Zip"]
                : " ",
              departure: event["Departure Time"],
              transportation: event["Transportation"],
              start: startISOString,
              end: allDay ? startISOString : new Date(date.getTime() + 2 * 60 * 60 * 1000).toISOString(), // Assuming a 2-hour game duration
              description: event["Description"],
              notes: event["Long Description"],
              opponent: event["Name"],
              time: event["Game Time"],
              location: event["Room Name"].length > 0 ? event["Room Name"] : event["Location"],
              allDay: allDay,
            });
        });
        console.log(results.data);
        setData(processed);
      },
    });

    // return () => document.head.removeChild(link);
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center" }}>
      <div className="docHeader">
        <div>
          <div>
            <b>Master Schedule Spreadsheet</b>
          </div>
          <div>
            {forWeekOfDay
              ? startOfWeek.getMonth() +
                1 +
                "/" +
                startOfWeek.getDate() +
                "/" +
                endOfWeek.getFullYear() +
                " - " +
                (endOfWeek.getMonth() + 1) +
                "/" +
                endOfWeek.getDate() +
                "/" +
                startOfWeek.getFullYear()
              : ""}
          </div>
        </div>
        <div>
          <b>Ethical Culture Fieldston School</b>
        </div>
        <div>
          <div>
            <b>GloriAnne DiToro</b>
          </div>
          <div>Phone: 718-329-7318</div>
          <div>gditoro@ecfs.org</div>
        </div>
      </div>
      <div className="notesContainer" style={{ width: "100%", fontSize: "smaller" }}>
        {data.map((event, index) => (
          <Fragment>
            <div style={{ pageBreakInside: "avoid" }}>
              <hr style={{ height: "3px", border: "none", color: "#333", backgroundColor: "#333" }} />

              <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: "left", width: "100%" }} key={index}>
                <div style={{ width: "20%" }}>
                  {new Date(event.date).toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}{" "}
                  - {event.time || "TBA"}
                </div>
                <div style={{ width: "30%" }}>{event.team}</div>
                <div style={{ width: "10%" }}>{event.away ? "Away" : "Home"}</div>
                <div style={{ width: "40%" }}>
                  {event.scrimmage
                    ? `${event.opponent} - (Scrimmage) `
                    : event.actualTitle.toLowerCase().indexOf("practice") > -1
                    ? "-- PRACTICE --"
                    : event.actualTitle.length > 0
                    ? `${event.actualTitle} - ${event.opponent}`
                    : event.opponent}
                  {event.isCancelled ? " (CANCELLED)" : event.isRescheduled ? " (RESCHEDULED)" : ""}
                </div>
                {event.dismissal ? <div style={{ width: "100%" }}>Dismissal: {event.dismissal}</div> : null}
                <div style={{ width: "100%" }}>Facility: {event.location}</div>
                <div style={{ width: "50%" }}>Transport: {event.transportation || "N/A"}</div>
                <div style={{ width: "50%" }}>Departs: {event.departure || "N/A"}</div>
                <div style={{ width: "100%", minHeight: ".75in" }}>Notes: {event.notes || " "}</div>
              </div>
            </div>
          </Fragment>
        ))}
      </div>
      {/* <div className="tableContainer">
        <table>
          <thead>
            <th>Date</th>
            <th>Day</th>
            <th>Sport</th>
            <th>Title</th>
            <th>Place</th>
            <th>Time</th>
            <th>Opponent</th>
            <th>Facility</th>
            <th>Dimissal</th>
            <th>Transportation</th>
            <th>Depart</th>
            <th>Notes</th>
            {showAddress ? <th>Address</th> : null}
          </thead>
          <tbody>
            {data.map((event, index) => (
              <tr key={index}>
                <td style={{ padding: 100 }}>{event.date}</td>
                <td>{new Date(event.date).toLocaleDateString("en-US", { weekday: "long" })}</td>
                <td>{event.team}</td>
                <td>{event.actualTitle}</td>
                <td>{event.away ? "Away" : "Home"}</td>
                <td>{event.time || "TBA"}</td>
                <td>
                  {event.scrimmage
                    ? `${event.opponent} - (Scrimmage) `
                    : event.actualTitle.toLowerCase().indexOf("practice") > -1
                    ? "-- PRACTICE --"
                    : event.opponent}
                </td>
                <td>{event.location}</td>

                <td>{event.dismissal || "N/A"}</td>
                <td>{event.transportation || "N/A"}</td>
                <td>{event.departure || " "}</td>
                <td>{event.notes || " "}</td>
                {showAddress ? <td>{event.address || " "}</td> : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </div>
  );
}
export default NotesSchedule;
